import SelectRemoteWidget from "./widget-selectRemote";
import SelectWidget from "./widget-select";
import CheckboxWidget from "./widget-checkbox"
import TimePickerWidget from "./widget-timePicker";

const widgets = {
  SelectRemoteWidget: SelectRemoteWidget,
  SelectWidget: SelectWidget,
  CheckboxWidget:CheckboxWidget,
  TimePickerWidget: TimePickerWidget
};

export default widgets;


// WEBPACK FOOTER //
// ./src/lib/widgets.js